import { CarrierType } from '../carrier/carrier-enum';

export class SRTubeValidationRequest {
    materialBarcode: string;

    carrierObjectID: string;

    carrierBarcode: string;

    carrierType: CarrierType;

    positionCol: number;

    positionRow: number;

    materialToDelete: boolean = false;

    labId: string;



}